import React, { useEffect } from 'react'
import { useState, useCallback } from 'react';
import axios from 'axios';
import { Input } from 'reactstrap'
import { MagnifyingGlass } from '@phosphor-icons/react';
import { toast } from 'react-toastify';
import PathName from '../../../components/PathName/PathName';
import WarningPopup from '../../../components/Popups/WarningPopup';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import RegistrationModal from '../../../components/Modal/RegistrationModal';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import Table from '../../../components/Table';
import { environment } from '../../../env';
import Switch from 'react-js-switch';
import { useSelector } from 'react-redux';
import ForgotPassword from '../../../components/Modal/ForgotPassword';



const Registration = () => {
    const [allUser, setallUser] = React.useState();
    const getAllUser = () => axios.get(`${environment.baseUrl}get-users`).then((response) => setallUser(response.data));
    const userdata = useSelector((state) => state?.Reducers?.userdata);
    // search name
    const searchName = (data) => debounce(data)
    const debounce = useCallback(_.debounce((_searchVal) => Search(_searchVal), 500), []);
    const Search = (query) => {
        let arr = []
        allUser?.filter((item) => {
            if (item?.user?.first_name.toUpperCase().includes(query.toUpperCase())) {
                return arr.push(item)
            }
        })
        if (arr?.length == 0) {
            return setallUser([])

        } else {
            return setallUser(arr)
        }
    }
    const loginActions = async (row) => {
        const payload = { is_active: !row?.user?.is_active, username: row?.user?.username, role: userdata?.role }
        try {
            await axios.put(`${environment.baseUrl}editprofile/${row?.user?.id}`, payload).then((form) => {
                if (form.data.code === 200) {
                    getAllUser();
                    toast.success('User Active Changed !');
                }
                else {
                    console.log("err");
                }
            })
        }
        catch (err) {
            console.log(err);
        }
    }
    const columns = [
        {
            name: 'Name',
            selector: row => row?.user?.first_name + ' ' + row?.user?.last_name,
            style: {
                fontSize: "2.3rem",
                width: '2px'
            }
        },
        {
            name: 'Username',
            selector: row => row?.user?.username,
            style: {
                fontSize: "2.3rem",
                width: '2px'
            }
        },
        {
            name: 'Email',
            selector: row => row?.user?.email,
            style: {
                fontSize: "2.3rem",
                width: '2px'
            }
        },
        {
            name: 'Status',
            selector: (row) => <div className=" d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${row.role === 'superadmin' && 'icon-bg-green icon-color-green '} ${row.role === 'admin' && 'icon-bg-yellow icon-color-yellow'} ${row.role == 'user' && 'status-bg-blue status-color-blue'} rounded-pill status-box2 rounded fs-3 base-font-600 px-5 text-capitalize`}>{row.role}</label>
            </div>,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Project Name',
            selector: row => row?.project?.name,
            style: {
                fontSize: "2.3rem",
                width: '2px'
            }
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-center align-items-center gap-2 ">
                <RegistrationModal button='edit' title='Edit Employee' datas={row} userLists={allUser} getAllUser={getAllUser} />
                <ForgotPassword button='edit' title='Edit Employee' datas={row} userLists={allUser} getAllUser={getAllUser} />
            </div>,
        },
        {
            name: 'Active',
            cell: (row) => <div className="d-flex justify-content-center align-items-center gap-2 ">
                <Switch
                    value={row?.user?.is_active}
                    onChange={() => loginActions(row)}
                    size={60}
                    backgroundColor={{ on: '#86d993', off: '#c6c6c6' }}
                    borderColor={{ on: '#86d993', off: '#c6c6c6' }} />
            </div>,
        },
    ];

    React.useEffect(() => {
        getAllUser()
    }, []);
    return (
        <>
            <PathName />
            <WarningPopup />
            <SuccessPopups />
            <div className="Registration-main">
                <div className='my-3 pb-1'>
                    <div className='d-flex align-items-center bg-white px-4 border-radius-10'>
                        <MagnifyingGlass size={30} />
                        <Input
                            className='p-4 border-0 shadow-none   w-100 fs-3 title-font-500 fs-2 '
                            type='text'
                            autoComplete='off'
                            placeholder='Search Registration Name Here...'
                            onChange={(e) => { searchName(e.target.value) }}
                        />
                    </div>
                    <br />
                </div>
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div >
                        <div className='d-flex justify-content-between align-items-center'>
                            <h1 className='title-font-bold '>Registration Employee</h1>
                            <RegistrationModal title='Create New Employee' userLists={allUser} getAllUser={getAllUser} />
                        </div>
                        {allUser?.length > 0 || allUser != undefined ? <Table columns={columns} data={allUser} /> : <EmptyTable />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Registration